import React from 'react';
export function SearchIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a7 7 0 104.377 12.463c1.354 1.63 3.435 3.85 6.623 7.037l1.5-1.5c-3.178-3.178-5.68-5.55-7.026-6.636A7 7 0 009 2zM4 9a5 5 0 1110 0A5 5 0 014 9z"
  }));
}